var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 18.75C9.12 18.75 8.06 18.15 7.45 17.18H4.14C2.96 17.18 2 16.19 2 14.98C2 14.17 2.42 13.46 3.07 13.07V9.59C3.07 6.2 5.28 3.25 8.38 2.38C8.64 1.58 9.38 1 10.24 1C11.1 1 11.83 1.58 12.1 2.38C15.21 3.25 17.41 6.2 17.41 9.59V13.06C18.07 13.44 18.5 14.16 18.5 14.97C18.5 16.18 17.54 17.17 16.36 17.17H13.05C12.43 18.15 11.39 18.74 10.25 18.74V18.75ZM10.24 2.5C9.99 2.5 9.79 2.73 9.78 3.01C9.78 3.36 9.52 3.66 9.18 3.73C6.51 4.27 4.57 6.74 4.57 9.59V13.57C4.57 13.92 4.33 14.22 4 14.3C3.71 14.37 3.5 14.65 3.5 14.98C3.5 15.36 3.79 15.68 4.14 15.68H7.89C8.18 15.68 8.45 15.85 8.57 16.12C8.88 16.81 9.54 17.25 10.24 17.25C10.94 17.25 11.6 16.82 11.92 16.12C12.04 15.85 12.31 15.68 12.6 15.68H16.35C16.7 15.68 16.99 15.36 16.99 14.98C16.99 14.66 16.79 14.38 16.5 14.3C16.16 14.23 15.9 13.93 15.9 13.57V9.59C15.9 6.74 13.96 4.27 11.29 3.73C10.95 3.66 10.7 3.36 10.69 3.01C10.69 2.73 10.47 2.5 10.23 2.5H10.24Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.f72752ba52d46bfdf9083b6c2f962e00.svg";
export { ForwardRef as ReactComponent };